<template>
<div class="about">
    <v-header />
    <v-sidebar />
    <div class="content-box-entity">
        <div class="content">
            <div>
                <div class="container">
                    <div class="handle-box">
                        <el-select v-model="query.username" style="width: 180px;" allow-create clearable filterable placeholder="邮箱">
                            <el-option v-for="item in outboxlist" :key="item" :label="item" :value="item">
                            </el-option>
                        </el-select>                      
                        <el-button type="primary" icon="el-icon-search" style="margin: 5px; width: 120px;" @click="handleSearch">搜索</el-button>
                    </div>
                    <div class="filter-container-right">
                        <el-button v-waves class="filter-item" style="margin-left: 5px; width: 90px;" type="primary" icon="el-icon-plus" @click="handleAdd">
                            添加
                        </el-button>
                    </div>
                    <el-table :data="tableData" border fit style="width: 100%;" class="table" ref="table" header-cell-class-name="table-header" size="mini" v-loading="listLoading" row-class-name="success-row" stripe
                    :cell-style="changColor" @selection-change="handleRowSelect" @row-click="handleClick">
                        <el-table-column prop="selects" type="selection" label="选择" width="50" align="center" />
                        <el-table-column type="index" width="50" label="序号" align="center"  />
                        <el-table-column prop="host" label="SMTP服务器地址"  width="200" align="center" ></el-table-column>
                        <el-table-column prop="username" label="邮箱" width="200" align="center" ></el-table-column>
                        <el-table-column prop="password" label="邮箱授权码"  width="210" align="center" >******</el-table-column>
                        <el-table-column prop="createdBy" label="创建人" align="center" ></el-table-column>
                        <el-table-column prop="createdAt" label="创建时间"  width="190" align="center" ></el-table-column>
            
                        <el-table-column label="操作" width="300px" fixed="right" align="center">
                            <template slot-scope="scope">
                                <el-button size="mini" class="filter-item" style="margin-left: 5px;" type="danger" icon="el-icon-delete" :disabled="lander.role=='1' " @click="handleDelete(scope.row)">
                                    删除
                                </el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                    <add-outbox ref="addOutbox" @addRefresh="addRefresh" />
                    <div class="pagination">
                        <el-pagination background @size-change="handleSizeChange" @current-change="handlePageChange" :current-page="query.pageNo" :page-sizes="[10,20,50,100,500]" :page-size="query.pageSize" layout="total, sizes, prev, pager, next, jumper" :total="pageTotal">
                        </el-pagination>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
</template>

<script>
import vHeader from "./Header.vue";
import vSidebar from "./Sidebar.vue";
import addOutbox from './addOutbox'
import {
    entity_del,
    entity_del_all,
    template_review,
    email_outbox_list_page,  
    email_outbox_del,
    email_outbox_getUsernames    
} from '../../api';
import {
    dealResult
} from "../../api/common";
import AddOutbox from './addOutbox.vue';
export default {
    name: "AdminOutbox",
    components: {
        vHeader,
        vSidebar,
        addOutbox,
        AddOutbox
    },
    data() {
        return {
            delMsgli: ["广告", "心术不正", "言辞不雅"],
            delVisible: false,
            delData: {},
            files: null,
            decimalPart: '', // 小数点后的字符
            msg: null,
            moveVisible: false,
            listLoading: false,
            FILE_ACTION: '',
            filteredOptions: [], // 用于存储过滤后的选项
            lander: {},
            trashNum: 0,
            typelist: [],
            countrylist: [],
            outboxlist: [],
            region2list: [],
            religionlist: [],
            languagelist: [],
            statuslist: [
                {
                    value: '是',
                    label: '是'
                },
                {
                    value: '否',
                    label: '否'
                }
            ],
            namelist: [],
            tableData: [],
            contypelist: [{
                    value: '线上',
                    label: '线上'
                },
                {
                    value: '线下',
                    label: '线下'
                }
            ],
            deleteSeleteData: {},
            query: {
                pageNo: 1,
                pageSize: 10,
            },
            pageTotal: 0,
            topbestVisible: false,
            dialogFormVisible: false,
            topbestData: {
                id: '',
                start: '',
                end: '',
            },
           
        };
    },
    methods: {

        addRefresh() {
            this.reload()
        },

        // 刷新数据
        reload() {
            this.handleSearch()
        },

        changColor({ row, column, rowIndex, columnIndex }) {
      if (columnIndex === 23 && row.status  === '是') {
        return { color: 'green' }
      }
      if (columnIndex === 23 && row.status === '否') {
        return { color: 'red' }
      }      
    },
        handleClick(row) {
            this.$refs.table.toggleRowSelection(row)
        },
        handleAdd() {
            this.$refs.addOutbox.open().then((that) => {
                that.initData(null, 'add')
            })
        },
        handleEdit(row) {
            this.$refs.addOutbox.open().then((that) => {
                that.initData(row, 'edit')
            })
        },
        // 查询操作
        handleSearch() {

            this.query.pageNo = 1;
            this.getPage();
        },

        // 分页导航
        handlePageChange(val) {
            this.query.pageNo = val;
            this.getPage();
        },
        handleSizeChange(val) {
            this.query.pageNo = 1;
            this.query.pageSize = val;
            this.getPage();
        },

        // 删除行
        handleDelete(row) {
            this.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                }
                email_outbox_del(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();
                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            })
        },

          // 删除行
        handleReview(row) {
            this.$confirm('确定审核通过该邮件内容?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                    id: row.id,
                }
                template_review(o).then((res) => {
                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }

                })
            })
        },
        handleRowSelect(selectionChange) {
            this.deleteSeleteData = selectionChange
        },
        handleDeleteAll() {
            this.$confirm('注意！此操作将永久删除全部记录, 请谨慎操作，是否继续?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then((res) => {
                let o = {
                    uid: this.lander.uid,
                    token: this.lander.token,
                }
                entity_del_all(o).then((res) => {
                    console.log(res);

                    dealResult(res.data);
                    if (res.data.status == 1) {
                        this.delVisible = false;
                        this.$message.success(res.data.msg);
                        this.getPage();

                    } else {
                        this.$message.error(res.data.msg)
                    }
                })
            })
        },

        handleDeleteSelect() {
            this.DeleteData = this.deleteSeleteData
            this.deleteSeleteData
            if (this.deleteSeleteData.length > 0) {
                this.$confirm('此操作将永久删除选中记录, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then((res) => {
                    let o = {
                        uid: this.lander.uid,
                        token: this.lander.token,
                    }
                    this.DeleteData.forEach(element => {
                        o.id = element.id
                        entity_del(o)

                    })
                    this.getPage();
                    this.$message({
                        type: 'info',
                        message: '删除成功'
                    })
                })
            } else {
                this.$message({
                    type: 'warning',
                    message: '请选择要删除的记录'
                })
            }
        },

        suredel() {
            let o = {
                uid: this.lander.uid,
                token: this.lander.token,
                type: this.topbestData.type,
                id: this.delData.id,
                delMsg: this.delData.delMsg,
            }
            admin_forum_del(o).then((res) => {
                dealResult(res.data);
                if (res.data.status == 1) {
                    this.delVisible = false;
                    this.$message.success(res.data.msg);
                    this.getPage();

                } else {
                    this.$message.error(res.data.msg)
                }

            })
        },

        //获取列表数据
        getPage() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            this.listLoading = true
            email_outbox_list_page(this.query).then((res) => {

                dealResult(res.data);
                if (res.data.status == 1) {
                    this.tableData = res.data.obj.list
                    this.pageTotal = res.data.obj.total //该页总共多少条记录
                } else {
                    this.$message.error(res.data.msg)
                }
                this.listLoading = false
            })
        },
        //去重获取列表数据
        getItems() {
            this.query.uid = this.lander.uid;
            this.query.token = this.lander.token;
            email_outbox_getUsernames(this.query).then((res) => {
                this.outboxlist = res.data.obj
            })          
        },
    

    },
    mounted() {
        this.lander = JSON.parse(this.$store.state.logininfo);
        //去后端查询所有的用户给tableData赋值
        this.getPage();       
        this.getItems();
        this.lander = JSON.parse(this.$store.state.logininfo);
        this.faceimg = this.lander.faceimg;
        this.FILE_ACTION = process.env.VUE_APP_API_ROOT + '/entity/entitylist/importExcel?uid=' + this.lander.uid + "&token=" + this.lander.token;
        if (this.lander.role == '100') {
        }
        if (this.lander.role == '50') {
        }
    }
}
</script>

<style scoped>
.handle-box {
    margin-bottom: 5px;
}

.handle-select {
    width: 120px;
}

.handle-input {
    width: 300px;
    display: inline-block;
}

.table {
    width: 100%;
    font-size: 14px;
}

.red {
    color: #ff0000;
}

.mr10 {
    margin-right: 10px;
    width: 150px;
}

.content-box-entity {
    position: absolute;
    left: 200px;
    right: 0;
    top: 0px;
    bottom: 0;
    padding-bottom: 30px;
    -webkit-transition: left .3s ease-in-out;
    transition: left .3s ease-in-out;
    background: #f0f0f0;
}

.filter-container-right {
    float: right;
}

.pagination {
    display: inline-block;
    padding-left: 200px;
    margin: 20px 0;
    border-radius: 4px;
}

.drawer-item {
    color: rgba(0, 0, 0, .65);
    font-size: 16px;
    padding: 12px 0;
}

.drawer-title {
    margin-bottom: 1px;
    margin-top: 15px;
    color: rgba(0, 0, 0, .85);
    font-size: 22px;
    line-height: 22px;
}

/*滚动条的宽度*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar {
    width: 6px;
    height: 10px;
}

/*滚动条滑块*/
/deep/ .el-table__body-wrapper::-webkit-scrollbar-thumb {
    background-color: #409eff;
    border-radius: 3px;
}
</style>
